module.exports = __webpack_public_path__ + "static/google-plus-logo-button-ad2b950e3e7845d9e6fd6985dd9e38c6.png";